import React from 'react';

import NumberInput from '@ui/NumberInput';
import Slider from '@ui/Slider';

interface NumberInputWithSliderProps {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  min: number;
  max: number;
  step?: number;
  placeholder?: string;
  prefix?: string;
  minLabel?: string;
  maxLabel?: string;
  className?: string;
  disabled?: boolean;
  /** Whether to show a tooltip with formatted value on hover */
  showTooltip?: boolean;
  /** Custom tooltip content (overrides default formatted value) */
  tooltipContent?: string;
}

const NumberInputWithSlider: React.FC<NumberInputWithSliderProps> = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  placeholder,
  prefix,
  minLabel,
  maxLabel,
  className = '',
  disabled = false,
  showTooltip = false,
  tooltipContent,
}) => {
  const handleSliderChange = (newValue: number) => {
    onChange(newValue);
  };

  return (
    <div className={className}>
      <NumberInput
        label={label}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        placeholder={placeholder}
        prefix={prefix}
        className="mb-0"
        disabled={disabled}
        showTooltip={showTooltip}
        tooltipContent={tooltipContent}
      />

      <Slider
        value={value || min}
        onChange={handleSliderChange}
        min={min}
        max={max}
        step={step}
        minLabel={minLabel}
        maxLabel={maxLabel}
        disabled={disabled}
      />
    </div>
  );
};

export default NumberInputWithSlider;
